/**
 * I passi del tutorial guidato del Monitor Spedizioni.
 *
 * Nessun preparativo: la pagina non ha menu, schede o pannelli da aprire, quindi
 * non serve nemmeno un `onStop` che la rimetta a posto.
 *
 * Lo scope tiene i bersagli di questa pagina separati da quelli delle altre
 * (il tracking della spedizione ora e' una pagina a parte).
 */
const at = name => `[data-tour-scope="shippings-monitor"] [data-tour="${name}"]`;

export function createShippingsMonitorTourSteps() {
	return [
		{
			body: "Questa pagina non serve a creare spedizioni ma a sorvegliarle. Ogni spedizione partita viene interrogata a intervalli regolari per sapere dove si trova: qui si vede chi e' ancora sotto osservazione, chi e' arrivato e soprattutto chi si e' fermato per strada. L'elenco si ricarica da solo ogni mezz'ora, quindi lo si puo' lasciare aperto su uno schermo.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'A cosa serve questa pagina',
		},
		{
			body: "Questi quattro pulsanti sono il cuore della pagina, e dividono le spedizioni secondo due cose sole: se il monitoraggio e' acceso e da quanti giorni la spedizione e' partita. In Corso sono quelle sorvegliate da meno di cinque giorni, cioe' la normalita'. In Ritardo sono sorvegliate da cinque giorni o piu' - ancora in viaggio quando non dovrebbero esserlo: e' la lista su cui si lavora, e infatti li' l'ordinamento si rovescia per mettere in cima le piu' vecchie. Completate sono quelle con il monitoraggio spento. Tutte toglie la distinzione.",
			key: 'modes',
			placement: 'bottom',
			target: at('modes'),
			title: 'I quattro pulsanti',
		},
		{
			body: "La ricerca guarda numero d'ordine, nome del destinatario e numero di tracking, e si lancia con Invio o con la lente. Due cose da sapere: cerca dall'inizio, non in mezzo - mezzo tracking non basta, va dato il principio - e serve dal quarto carattere in su. Con tre caratteri il campo sembra accettare, ma l'elenco resta quello di prima.",
			key: 'search',
			placement: 'bottom',
			target: at('search'),
			title: 'Cercare una spedizione',
		},
		{
			body: "Corriere restringe al vettore che ha in mano il pacco, Platform al canale da cui arriva l'ordine. Data spedizione lavora a intervallo sul giorno in cui la spedizione e' stata creata - non sulla data dell'ordine, che nella tabella e' una colonna a parte. I filtri si sommano al pulsante scelto sopra, non lo sostituiscono.",
			key: 'filters',
			placement: 'bottom',
			target: at('filters'),
			title: 'Restringere ancora',
		},
		{
			body: "Una riga per spedizione, non per ordine. Le due date vanno lette insieme e sono diverse: Data Ordine e' quando il cliente ha comprato, Data Spedizione quando il pacco e' partito - la distanza fra le due dice quanto ci hai messo tu, quella fra Data Spedizione e oggi quanto ci sta mettendo il corriere. Ultimo Agg. e' l'ultima volta che il corriere ha dato notizie: se e' fermo da giorni, il pacco probabilmente e' bloccato.",
			key: 'table',
			placement: 'bottom',
			/*
			 * L'intestazione, non la tabella intera: con quindici spedizioni la tabella
			 * e' piu' alta dello schermo e il ritaglio coprirebbe tutto il visibile,
			 * facendo sembrare sparito il velo.
			 */
			target: `${at('table')} thead`,
			timeout: 250,
			title: 'Come si legge la tabella',
		},
		{
			body: "I tre pallini a inizio riga raccolgono le azioni sulla spedizione: Tracking spedizione, Apri ordine, Scarica etichetta e Monitora / Togli dal monitoraggio. Tracking e ordine si aprono come pagine, e Indietro riporta qui con la stessa modalita', gli stessi filtri e la stessa pagina.",
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			timeout: 250,
			title: 'Le azioni della riga',
		},
		{
			body: "L'icona accanto ai tre pallini accende e spegne la sorveglianza su quella spedizione. La X la toglie dalla coda: si usa quando il pacco e' arrivato ma il corriere non lo dichiara, o quando il tracking e' sbagliato e continuare a interrogarlo non serve. Il piu' verde la rimette in coda e fa ripartire subito un controllo. Sulle spedizioni gia' risultate consegnate non compare nulla: non c'e' piu' niente da seguire.",
			key: 'monitor-toggle',
			placement: 'right',
			target: at('monitor-toggle'),
			timeout: 250,
			title: 'Accendere e spegnere il monitoraggio',
		},
		{
			body: "Il colore dell'etichetta Stato riassume la situazione in un colpo d'occhio, e sono quattro. Blu: sorvegliata, partita da meno di cinque giorni, tutto regolare. Rosso, con il triangolo d'allarme accanto: sorvegliata da cinque giorni o piu'. Verde: monitoraggio chiuso e lo stato dice consegnato. Arancio: monitoraggio chiuso ma lo stato non dice consegnato - e' il colore da guardare per primo, perche' vuol dire che abbiamo smesso di seguire un pacco che non risulta arrivato.",
			key: 'status',
			placement: 'top',
			target: at('status'),
			timeout: 250,
			title: 'I quattro colori dello stato',
		},
		{
			body: "Il testo nell'etichetta e' quello che manda il corriere, tagliato per stare in riga: passandoci sopra si legge per intero. L'icona accanto al numero di tracking apre il dettaglio completo, cioe' i passaggi registrati uno per uno - presa in carico, partenza, transito, tentativi di consegna. E' li' che si capisce dove un pacco si e' fermato.",
			key: 'tracking',
			placement: 'top',
			target: at('tracking'),
			timeout: 250,
			title: 'Il dettaglio dei passaggi',
		},
		{
			body: "LDV e' la lettera di vettura, l'etichetta del pacco: compare solo sulle spedizioni che ne hanno una generata da qui, e serve quando va ristampata. Le spedizioni registrate a mano, senza etichetta comprata dal sistema, hanno questa casella vuota.",
			key: 'label',
			placement: 'top',
			target: at('label'),
			timeout: 250,
			title: "Ristampare l'etichetta",
		},
	];
}
